module.exports = __webpack_public_path__ + "img/曲线2.f6b7c033.png";